module.exports = __webpack_public_path__ + "static/media/app_testing.9e2bfe0c.jpg";